import { Log } from "@fanfanlo";
import { II18nValueConf } from "@fanfanlo";
import { googleGeminiIntersectionLocale } from '@0xff336699/js-i18n-lngs';

const fileLog = new Log(false, 'IEntityDescription_f');
fileLog.pause = true;
fileLog.childrenPaused = true;

/**
 * 描述内容类型枚举
 */
export enum DescriptionContentType {
    TEXT = 'text',
    URL = 'url',
    HTML = 'html'
}

/**
 * 一行简介内容类型（仅TEXT和HTML）
 */
export type BriefDescriptionType =
    | DescriptionContentType.TEXT
    | DescriptionContentType.HTML;

/**
 * 描述内容接口
 */
export interface IDescriptionContent {
    type: DescriptionContentType
    content: string
    i18n?: II18nValueConf  // 用于UI标签的国际化
}

/**
 * 一行简介接口
 */
export interface IBriefDescription {
    type: BriefDescriptionType
    content: string
}

/**
 * 源语言类型（使用 googleGeminiIntersectionLocale 的 key）
 */
export type SourceLanguage = keyof typeof googleGeminiIntersectionLocale;

/**
 * 实体描述信息接口
 * 重命名自 INameContainer，用于存储实体的名称和多级描述信息
 */
export interface IEntityDescription {
    // === 现有字段 ===
    // name如果没有就默认未命名
    name?: string
    description?: string  // 保留，向后兼容
    i18n?: II18nValueConf

    // === 新增字段 ===
    // 源语言（用户内容的原始语言）
    // 可以用于自动翻译
    sourceLang?: SourceLanguage

    // 一行简介 - 仅支持文本或HTML（不支持URL）
    briefDescription?: IBriefDescription

    // 简介 - 支持文本、URL或HTML
    summary?: IDescriptionContent

    // 完整介绍 - 支持文本、URL或HTML
    fullIntroduction?: IDescriptionContent
}
